import * as types from './types';

export const sidebarChangePanel = ({ commit }, panel) => {
  commit(types.SIDEBAR_UPDATE_VISIBILITY, panel);
};

export const sidebarChangeActiveButton = ({ commit }, button) => {
  commit(types.SIDEBAR_UPDATE_ACTIVE_BUTTON, button);
};

export const sidebarSetElement = ({ commit }, element) => {
  commit(types.SIDEBAR_SET_ELEMENT, element);
};

export const sidebarResetState = ({ commit }) => {
  commit(types.SIDEBAR_RESET_STATE);
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/sidebar/actions.js
 **/